<template>
  <v-card flat>
    <v-card-text>
      <!-- Summary Cards -->
      <v-row v-if="report" class="mb-4">
        <v-col cols="6" sm="4">
          <v-card color="blue darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.total_months }}
            </div>
            <div class="caption">Total Months</div>
          </v-card>
        </v-col>
        <v-col cols="6" sm="4">
          <v-card color="green darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ formatCurrency(report.grand_total_revenue) }}
            </div>
            <div class="caption">Grand Total Revenue</div>
          </v-card>
        </v-col>
        <v-col cols="6" sm="4">
          <v-card color="purple darken-1" dark class="pa-3 text-center" flat>
            <div class="text-h5 font-weight-bold">
              {{ report.grand_total_services_rendered }}
            </div>
            <div class="caption">Total Services Rendered</div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Data Table -->
      <v-data-table
        v-if="report"
        :items="report.items"
        :headers="headers"
        dense
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [10, 25, 50, -1] }"
        :sort-by="['year', 'month_number']"
        :sort-desc="[false, false]"
        multi-sort
      >
        <template v-slot:item.revenue="{ item }">
          <span class="font-weight-bold green--text text--darken-2">
            {{ formatCurrency(item.revenue) }}
          </span>
        </template>
        <template v-slot:item.revenue_growth="{ item }">
          <v-chip
            v-if="item.revenue_growth !== null"
            :color="item.revenue_growth >= 0 ? 'green' : 'red'"
            dark
            small
          >
            {{ item.revenue_growth >= 0 ? "+" : "" }}{{ item.revenue_growth }}%
          </v-chip>
          <v-chip v-else color="grey" dark small>N/A</v-chip>
        </template>
        <template v-slot:item.count_growth="{ item }">
          <v-chip
            v-if="item.count_growth !== null"
            :color="item.count_growth >= 0 ? 'green' : 'red'"
            dark
            small
          >
            {{ item.count_growth >= 0 ? "+" : "" }}{{ item.count_growth }}%
          </v-chip>
          <v-chip v-else color="grey" dark small>N/A</v-chip>
        </template>
      </v-data-table>

      <!-- Empty State -->
      <div v-if="!report" class="text-center grey--text pa-10">
        <v-icon size="64" color="grey lighten-1">mdi-chart-line</v-icon>
        <p class="mt-4 subtitle-1">
          Click "Generate" to see monthly service trends.
        </p>
        <p class="caption grey--text">
          Uses the date range from the filters above. Default: last 30 days.
        </p>
      </div>

      <!-- No Results -->
      <div
        v-if="report && report.items && report.items.length === 0"
        class="text-center pa-10"
      >
        <v-icon size="64" color="grey">mdi-chart-line-variant</v-icon>
        <p class="mt-4 subtitle-1 grey--text">
          No service trend data found for the selected period.
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "MonthlyServiceTrends",
  props: {
    filters: { type: Object, required: true },
  },
  data() {
    return {
      report: null,
      headers: [
        { text: "Month", value: "month" },
        {
          text: "Services Rendered",
          value: "services_rendered",
          align: "center",
        },
        { text: "Total Qty", value: "total_qty", align: "center" },
        { text: "Revenue", value: "revenue", align: "end" },
        {
          text: "Unique Customers",
          value: "unique_customers",
          align: "center",
        },
        { text: "Unique Services", value: "unique_services", align: "center" },
        { text: "Revenue Growth", value: "revenue_growth", align: "center" },
        { text: "Count Growth", value: "count_growth", align: "center" },
      ],
    };
  },
  methods: {
    ...mapActions({
      fetchReport: "service_reports/get_monthly_trends_report",
    }),
    formatCurrency(value) {
      if (!value && value !== 0) return "0.00";
      return Number(value).toLocaleString("en-PH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async generate() {
      try {
        let params = {};
        if (this.filters.from_date) params.from_date = this.filters.from_date;
        if (this.filters.to_date) params.to_date = this.filters.to_date;
        if (this.filters.branch_id) params.branch_id = this.filters.branch_id;
        let data = await this.fetchReport(params);
        this.report = data;
      } catch (e) {
        this.$alert({
          title: "Error",
          message:
            "Error generating monthly trends: " +
            (e.response?.data?.error || e.message),
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
    },
  },
};
</script>
